import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box, MenuRenderer, Text, Inline, IconLanguage, IconChevron, MenuItemLink, IconTick, Strong } from "braid-design-system";
import { analyticsLanguageSelectorEvents, analyticsEvents } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { siteConfig, languages } from "@seek/melways-sites";
import { compact, full } from "./LanguageSelector.css.mjs";
const languageMapping = {
  en: "English",
  id: "Bahasa",
  th: "ภาษาไทย"
};
const getLanguagesForSelector = (site) => {
  const languages2 = siteConfig[site].languages;
  if (Array.isArray(languages2) && isAtLeastTwoLanguages(languages2)) {
    return languages2;
  }
  return;
};
const isAtLeastTwoLanguages = (languages2) => languages2.length > 1;
const getWindowPathWithoutLanguage = () => {
  if (typeof window === "undefined") {
    return "/";
  }
  let path = window.location.pathname;
  const pathArray = path.split("/");
  if (languages.find((language) => language === pathArray[1])) {
    pathArray.splice(1, 1);
    path = pathArray.join("/") || "/";
  }
  return path + window.location.search + window.location.hash;
};
const LanguageSelector = ({
  language = "en",
  site,
  displayAsCompact = false,
  urlResolver
}) => {
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const languages2 = getLanguagesForSelector(site);
  if (!languages2) {
    return null;
  }
  const strippedPath = getWindowPathWithoutLanguage();
  return /* @__PURE__ */ jsx(Box, { "data-testid": "languageSelector", children: /* @__PURE__ */ jsx(
    MenuRenderer,
    {
      reserveIconSpace: true,
      align: "right",
      offsetSpace: "large",
      width: "small",
      onOpen: () => {
        handleInteractionTracking(analyticsLanguageSelectorEvents.toggleOpen);
      },
      onClose: () => {
        handleInteractionTracking(
          analyticsLanguageSelectorEvents.toggleClosed
        );
      },
      trigger: (triggerProps, { open }) => /* @__PURE__ */ jsx(
        Box,
        {
          userSelect: "none",
          cursor: "pointer",
          ...triggerProps,
          className: [
            {
              [compact]: displayAsCompact,
              [full]: !displayAsCompact
            }
          ],
          children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", children: [
            /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", children: [
              /* @__PURE__ */ jsx(IconLanguage, {}),
              /* @__PURE__ */ jsx(Box, { "data-testid": "languageSelectorLabel", children: displayAsCompact ? language.toUpperCase() : languageMapping[language] })
            ] }),
            /* @__PURE__ */ jsx(
              IconChevron,
              {
                direction: open ? "up" : "down",
                alignY: "lowercase"
              }
            )
          ] }) })
        }
      ),
      children: languages2.map((languageOption) => {
        const href = urlResolver({
          language: languageOption,
          path: strippedPath
        });
        return /* @__PURE__ */ jsx(
          MenuItemLink,
          {
            href,
            data: {
              analytics: analyticsEvents.trackSelectLanguage(
                false,
                languageOption
              )
            },
            icon: languageOption === language && /* @__PURE__ */ jsx(IconTick, { tone: "positive" }),
            onClick: () => {
              handleInteractionTracking({
                ...analyticsLanguageSelectorEvents.languageSelected,
                actionPressed: `language selected - ${languageOption}`
              });
              window.location.href = href;
            },
            children: languageOption === language ? /* @__PURE__ */ jsx(Strong, { children: languageMapping[languageOption] }) : /* @__PURE__ */ jsx(Fragment, { children: languageMapping[languageOption] })
          },
          languageOption
        );
      })
    }
  ) });
};
export {
  LanguageSelector,
  getLanguagesForSelector,
  getWindowPathWithoutLanguage,
  languageMapping
};
